import * as kpisApi from '../api/kpis'
import { handleApiError } from './api-errors'

export const FETCH_KPIS = "FETCH_KPIS"

export const fetchKPIs = () => (dispatch) => {
    kpisApi.getObj().then(res => {
        dispatch({
            type: FETCH_KPIS,
            payload: res
        })
    }).catch(err => dispatch(handleApiError(err)))
}
